<template>
  <v-container fluid class="px-0 py-0">
    <v-layout row nowrap>
      <v-flex sm5 md4 lg3 class="px-3 py-3">
        <v-card>
          <v-list subheader three-line v-if="rule.reqNum > 0">
            <v-subheader>必学</v-subheader>
            <v-list-tile v-for="c in requires" :key="c.id" @click="onCourseware(c)">
              <v-list-tile-content>
                <v-list-tile-title>{{ c.name || c.coursewareName }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-chip small v-if="coursewares[c.id] && coursewares[c.id].passed" color="green" text-color="white">
                    已通过
                  </v-chip>
                  <v-chip small v-else color="red" text-color="white">未通过</v-chip>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="c.scoreMode == 1">已得{{
                    coursewares[c.id]
                      ? coursewares[c.id].passed
                        ? c.coursewareScore
                        : coursewares[c.id].duration
                      : 0
                  }}学时/总{{ c.coursewareScore }}学时 |</span>
                  已学{{
                    (
                      (coursewares[c.id]
                        ? coursewares[c.id].passed
                          ? c.coursewareDur
                          : coursewares[c.id].strictDuration
                        : 0) / 60
                    ).toFixed(0)
                  }}分钟/总{{ (c.coursewareDur / 60).toFixed(0) }}分钟
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-list subheader three-line v-if="rule.optNum > 0">
            <v-subheader>选学</v-subheader>
            <v-list-tile v-for="c in opts" :key="c.id" @click="onCourseware(c)">
              <v-list-tile-content>
                <v-list-tile-title>{{ c.name || c.coursewareName }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-chip small v-if="coursewares[c.id] && coursewares[c.id].passed" color="green" text-color="white">
                    已通过
                  </v-chip>
                  <v-chip small v-else color="red" text-color="white">未通过</v-chip>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="c.scoreMode == 1">已得{{
                    coursewares[c.id]
                      ? coursewares[c.id].passed
                        ? c.coursewareScore
                        : coursewares[c.id].duration
                      : 0
                  }}学时/总{{ c.coursewareScore }}学时 |</span>
                  已学{{
                    (
                      (coursewares[c.id]
                        ? coursewares[c.id].passed
                          ? c.coursewareDur
                          : coursewares[c.id].strictDuration
                        : 0) / 60
                    ).toFixed(0)
                  }}分钟/总{{ (c.coursewareDur / 60).toFixed(0) }}分钟
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-list subheader three-line v-if="rule.quizNum > 0">
            <v-subheader>考试</v-subheader>
            <v-list-tile v-for="c in papers" :key="c.id" @click="onPaper(c)">
              <v-list-tile-content>
                <v-list-tile-title>{{ c.paperName }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <div class="info-item">
                    <v-chip small v-if="quizs[c.id] && quizs[c.id].passed" color="green" text-color="white">已通过
                    </v-chip>
                    <v-chip small v-else color="red" text-color="white">未通过</v-chip>
                    <div v-if="
                      !cfg.archived && account.originTenantId === 0 && c.type == 1
                    ">
                      <v-menu v-model="c.menu">
                        <template v-slot:activator="{ on }">
                          <a href="javascript:;" @click.stop="on['click']" class="primary--text">
                            重置考试次数
                          </a>
                        </template>
                        <v-card>
                          <v-card-text style="text-align: center; max-width: 240px">是否重置考试次数</v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions class="justify-center">
                            <v-btn small flat @click="c.menu = false">取消</v-btn>
                            <v-btn small flat color="primary" @click="initTryCount(c)">确认</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </div>
                  </div>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="c.type == 1">考试 | 得分{{ quizs[c.id] ? quizs[c.id].score : 0 }}分/{{
                  c.passScore
                }}分通过 | 已考{{
                    quizs[c.id] ? quizs[c.id].tryCount : 0
                  }}次/最多可考{{ c.tryCount }}次
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="c.type == 2">练习 | 完成{{
                  quizs[c.id] && quizs[c.id].passCount
                    ? quizs[c.id].passCount
                    : 0
                }}题/{{ c.passScore }}题通过
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex sm7 md8 lg9 class="pl-3">
        <h2 class="primary--text">{{ title }}</h2>
        <v-divider class="my-2" />
        <component :is="componentName" :timestamp="timestamp" class="stuclazz-detail" :cfg="componentCfg"
          :defaultActiveFirst="false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Tree } from "javaee-fre";
import { mapState } from "vuex";

export default {
  name: "stuclazz-view",
  components: {
    tree: Tree,
  },
  props: {
    cfg: Object,
  },
  computed: {
    ...mapState(["account"]),
  },
  data() {
    return {
      rule: {},
      requires: [],
      opts: [],
      papers: [],
      componentName: "",
      componentCfg: {},
      title: "",
      quizs: {},
      coursewares: {},
      timestamp: Date.now(),
    };
  },
  watch: {
    cfg() {
      this.init();
    },
  },
  methods: {
    initTryCount(c) {
      let self = this,
        cfg = self.cfg;

      self.$axios
        .get(
          `/home/admin/my/tenant/clazz/stu/quiz/reset/trycount/${cfg.id}/${c.id}`
        )
        .then((r) => {
          if (r.data && r.data.status == "ok") {
            this.init();
            self.$status("重置成功", "success");
          } else {
            self.$status("重置失败", "error");
          }
        });
    },
    onCourseware(c) {
      let self = this,
        cfg = self.cfg;
      self._cHash = {};
      self.$axios
        .get(
          `/home/admin/my/tenant/clazz/${cfg.archived ? "a_" : ""
          }stu/cw/detail/${cfg.id}/${c.id}`,
          {
            params: { _clazzId: cfg.clazzId, _arch: cfg.archived },
          }
        )
        .then((r) => {
          if (r.data && r.data.status == "ok") {
            self._cHash = r.data.message;
          }
          self.componentCfg = {
            url() {
              return `/home/my/courseware/items/list/${c.coursewareId}`;
            },
            label(i) {
              if (i) {
                let l = self._cHash[i.id] || {};
                if (!i.children || i.children.length == 0) {
                  return `${i.label} - (<span style="color:${l.passed ? "green" : "red"
                    }">${l.passed ? "通过" : "未通过"}</span> ${c.scoreMode == 1
                      ? "| 获得学时:" +
                      (l.passed ? i.score : l.duration || 0).toFixed(0) +
                      "/要求学时:" +
                      i.score
                      : ""
                    } | 已学时长:${(
                      (l.passed ? i.mediaDur : l.strictDuration || 0) / 60
                    ).toFixed(0)}分钟/要求时长:${(i.mediaDur / 60).toFixed(
                      0
                    )}分钟)</span>`;
                } else {
                  return i.label;
                }
              }
              return "";
            },
          };
          self.componentName = "tree";
          self.timestamp = Date.now();
        });
      self.title = c.name || c.coursewareName;
    },
    onPaper(c) {
      let self = this,
        cfg = self.cfg;
      self.$axios
        .get(
          `/home/admin/my/tenant/clazz/${cfg.archived ? "a_" : ""
          }stu/quiz/detail/${cfg.id}/${c.id}`,
          {
            params: { _clazzId: cfg.clazzId, _arch: cfg.archived },
          }
        )
        .then((r) => {
          self.componentCfg = {
            id: c.paperId,
            logs: r.data ? r.data.message || {} : {},
            draw: r.data ? r.data.draw || null : null,
            exercise: r.data ? r.data.exercise || null : null,
          };
          if (r.data && r.data.exercise) {
            self.componentName = "exercise-view";
          } else {
            self.componentName = "paper-view";
          }
          self.timestamp = Date.now();
        });
      self.title = c.paperName;
    },
    loadRule() {
      let self = this,
        cfg = self.cfg;
      return self.$axios.get(`/home/my/crule/detail/${cfg.ruleId}`);
    },
    loadDetail() {
      let self = this,
        cfg = self.cfg;
      return self.$axios.get(
        `/home/admin/my/tenant/clazz/${cfg.archived ? "a_" : ""}stu/detail/${cfg.id
        }`,
        { params: { _clazzId: cfg.clazzId, _arch: cfg.archived } }
      );
    },
    parseRule(d) {
      let self = this,
        rule = d.message,
        requires = [],
        opts = [];
      if (d.coursewares) {
        for (let i in d.coursewares) {
          let c = d.coursewares[i];
          if (c.optional) {
            opts.push(c);
          } else {
            requires.push(c);
          }
        }
      }

      self.requires = requires;
      self.opts = opts;
      self.papers = d.papers.map((p) => Object.assign({ menu: false }, p));
      self.rule = rule;

      if (requires.length > 0) {
        self.onCourseware(requires[0]);
      } else if (opts.length > 0) {
        self.onCourseware(opts[0]);
      } else if (d.papers.length > 0) {
        self.onPaper(d.papers[0]);
      }
    },
    parseDetail(d) {
      let self = this;
      d = d.message;
      self.coursewares = d.coursewares || {};
      self.quizs = d.quizs || {};
    },
    init() {
      let self = this,
        cfg = self.cfg;
      if (cfg && cfg.ruleId) {
        self.$axios.all([self.loadRule(), self.loadDetail()]).then(
          self.$axios.spread((rr, dr) => {
            if (!dr.data || dr.data.status != "ok") {
              return;
            }
            self.parseDetail(dr.data);

            if (!rr.data || rr.data.status != "ok") {
              return;
            }
            self.parseRule(rr.data);
          })
        );
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
.stuclazz-detail .v-treeview-node__label label.crud-tree-view-label {
  max-width: 100%;
}

.info-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
